const setNewShorthand = (state, action) => {
  state.settings = action.payload;
};

export default {
  setNewShorthand,
};
